import classNames from "classnames"
import React from "react"

import { Color } from "../../../../constants/V2/color"
import CircleExclamationIcon from "../Icons/CircleExclamationIcon"
import Typography from "../Typography"

interface Props {
  error: string
  className?: string
  "data-testid"?: string
}

const InputError = ({ error, className, "data-testid": dataTestId }: Props) => {
  return (
    <div className="mt-[5px] flex gap-[5px] text-center">
      <CircleExclamationIcon className="text-orange" />
      <Typography
        color={Color.Orange}
        text={error}
        font="grotesk"
        size="body-sm"
        weight="book"
        className={classNames("pt-[1px]", className)}
        data-testid={dataTestId}
      />
    </div>
  )
}

export default InputError
